<template>
	<div class="webviewtest">
		<van-button type="primary" @click="switchTab">Tab跳转</van-button>
		<van-button type="warning" @click="showModal(true)">确认框（原生）</van-button>
		<van-button type="info" @click="showModal(false)">确认框（vant）</van-button>
		<van-button type="danger" @click="showLoading">显示加载框</van-button>
		<van-button type="primary" @click="showToast">提示消息</van-button>
		<van-button type="primary" @click="plusModal">测试PLUS</van-button>
		<van-button type="primary" @click="setNavigationBarTitle">设置标题</van-button>

		<van-button type="primary" @click="plusModal2">设置标题2</van-button>
		
		<nut-buttongroup shape="circle">
			<nut-button type="light">重置</nut-button>
			<nut-button>确定</nut-button>
		</nut-buttongroup>

		<nut-calendar
			:is-visible="isVisible"
			:default-value="date"
			@close="switchPicker('isVisible')"
			@choose="setChooseValue"
			:start-date="`2018-10-11`"
			:end-date="`2020-11-11`"
		></nut-calendar>
	</div>
</template>

<script>
 
window.setLoginToken = function(token) {
	suni.showModal({
		title: '抱歉',
		content: token,
		showCancel: false,
		success: res => {
			console.log(JSON.stringify(res));
		}
	});
};
export default {
	data() {
		return {
			isVisible: false,
			date: null
		};
	},
	created() {
		// document.addEventListener('cstUniAppJSBridgeReady', function(e) {
		// 	console.log('cstUniAppJSBridgeReady---' + JSON.stringify(e));
		// });
	},
	methods: {
		switchPicker(param) {
			console.log(JSON.stringify(param));
		},
		setChooseValue(param) {
			console.log(JSON.stringify(param));
		},
		setNavigationBarTitle() {

			//this.isVisible = true;
			// this.$toast.text('提示信息');
			// this.$dialog({
			// 	title: '确定删除此订单？',
			// 	content: '删除后将从你的记录里消失，无法找回'
			// });
			// const clipboard = weex.requireModule('clipboard');
			// console.log(JSON.stringify( clipboard ))
			// clipboard.setString('啊好啊哈啊哈啊哈啊哈212512');
			// clipboard.getString(ret => {
			// 	plus.nativeUI.toast(ret.data);
			// });
		},
		plusModal2(){
			if(window.__dcloud_weex_postMessage) {
								__dcloud_weex_postMessage({"a":"b"});
							} else {
								window.__dcloud_weex_.postMessage({"a":"b"});
							}
		},
		plusModal() {
			suni.plus()
				.then(plus => {
					plus.device.beep();
					plus.nativeUI.toast('获得设备的型号\n' + plus.device.model);
				})
				.catch(err => {
					suni.showModal({
						title: '抱歉',
						content: '您当前访问的并不是APP环境！',
						showCancel: false,
						success: res => {
							console.log(JSON.stringify(res));
						}
					});
				});
		},
		switchTab() {
			suni.navigateTo({
				url:"/pages/index/test/test"
			})
			suni.switchTab({
				url: '/pages/extend/extend'
			});
		},
		showModal(plus) {
			suni.showModal({
				title: '你好',
				content: '很高兴认识你！',
				showCancel: true,
				plus: plus,
				success: res => {
					console.log(JSON.stringify(res));
				}
			});
		},
		showLoading() {
			suni.showLoading();
		},
		showToast() {
			suni.showToast({
				title: '你好啊',
				duration: '5000',
				complete: toast => {
					setTimeout(function() {
						toast.message = '改变文字哦~';
					}, 800);
				},
				close: toast => {
					console.log('close');
				},
				success: toast => {
					console.log('success');
				}
			});
		}
	}
};
</script>

<style>
.webviewtest {
	width: 90%;
	margin: 0 auto;
	text-align: center;
}
.webviewtest button {
	width: 80%;
	margin: 0 auto;
	margin-top: 20px;
}
.van-toast--text {
	padding: 10px 15px;
}
</style>
